import { env } from '@lcsc-ui/utils/baseUrl';
import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';

const staticDataUrl = `https://${env === 'pro' ? '' : env}staticdata.szlcsc.com`;

export function getCatalotgPopAd(params) {
  return sendAxios({
    method: 'get',
    params,
    url: `/advertising/index/catalog/advertising`,
    baseURL: Domains.lcscOpUrl,
  });
}
export function getJlcWebsiteGroup() {
  return sendAxios({
    method: 'get',
    url: `/common/data/www-website-jlcgroup.json?timestamp=${Date.now()}`,
    baseURL: env == 'local' ? Domains.lcscWwwUrl : staticDataUrl,
  });
}
export function getRecommendDropWordUserList() {
  return sendAxios({
    method: 'get',
    url: `/v2/recommend/drop/word/user/list?limit=4`,
    baseURL: Domains.lcscOpUrl,
  });
}
export function getAssociationalWordList(params) {
  return sendAxios({
    method: 'get',
    params,
    url: `/search/searchTip`,
    baseURL: Domains.lcscSotipUrl,
  });
}
export function getPlusInfo() {
  return sendAxios({
    method: 'get',
    url: `/v2/plus/expire/info`,
    baseURL: Domains.lcscActivityUrl,
  });
}
// export function postDataToGlobalSearch(targetUrl, formData) {
//   return axiosInstance({
//     method: 'get',
//     baseURL: '',
//     data: formData,
//     url: targetUrl,
//   });
// }
export function checkKeyWord(url) {
  return sendAxios({
    method: 'get',
    baseURL: Domains.lcscSearchUrl,
    url,
  });
}
export function updateChecked(data) {
  return sendAxios({
    method: 'post',
    baseURL: Domains.lcscWwwUrl,
    data,
    url: '/page/home/cart/update/checked',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
export function updatePanelChecked(data) {
  return sendAxios({
    method: 'post',
    baseURL: Domains.lcscWwwUrl,
    data,
    url: '/async/page/home/panel/cart/select/update',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function getCartDataApi() {
  return sendAxios({
    method: 'get',
    url: `/page/home/cart/display?isInit=true`,
    baseURL: Domains.lcscCartUrl,
  });
}

export function getPanelCartDataApi() {
  return sendAxios({
    method: 'get',
    url: `/async/page/home/panel/cart/list?isInit=true`,
    baseURL: Domains.lcscWwwUrl,
  });
}

// export function getCatalogList() {
//   return sendAxios({
//     method: 'get',
//     url: `/resource/catalog/list/new`,
//     baseURL: Domains.lcscOpUrl,
//   });
// }

export function bomUploadCheck(data) {
  return sendAxios({
    method: 'post',
    url: `/bom/json/upload/check`,
    baseURL: Domains.lcscBomUrl,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function bomUpload(data) {
  return sendAxios({
    method: 'post',
    url: `/bom/json/upload`,
    baseURL: Domains.lcscBomUrl,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function deletePanelGoods(data) {
  return sendAxios({
    method: 'post',
    url: `/async/page/home/panel/cart/delete`,
    baseURL: Domains.lcscWwwUrl,
    data,
  });
}

export function deleteGoods(data) {
  return sendAxios({
    method: 'post',
    url: `/page/home/cart/delete`,
    baseURL: Domains.lcscWwwUrl,
    data,
  });
}

export function getMroResourceList() {
  return sendAxios({
    method: 'get',
    url: `/common/data/mro-resource-list.json`,
    baseURL: env == 'local' ? Domains.lcscWwwUrl : staticDataUrl,
  });
}
